import { render, staticRenderFns } from "./inspectProject.vue?vue&type=template&id=6a901a07&scoped=true&"
import script from "./inspectProject.vue?vue&type=script&lang=js&"
export * from "./inspectProject.vue?vue&type=script&lang=js&"
import style0 from "./inspectProject.vue?vue&type=style&index=0&id=6a901a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a901a07",
  null
  
)

export default component.exports